import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import AiOraBoard from './AiOraBoard';
import { getAiOraQuestionScore } from '../actions';
import {
    selectApiParams,
    selectApiCount,
    selectFiltersApplied,
    getErrorInfo,
    selectFilters,
    selectAiOraQuestionScore,
    selectAiOraQuestionScoreFetched,
} from '../selector';
import { getDefaultSettings } from '../../Login/selector';

const stateToProps = createStructuredSelector({
    apiParams: selectApiParams(),
    apiLoadingCount: selectApiCount(),
    activeFilter: selectFiltersApplied(),
    errorInfo: getErrorInfo(),
    filters: selectFilters(),
    defaultSettings: getDefaultSettings(),
    aiOraQuestionScore: selectAiOraQuestionScore(),
    aiOraQuestionScoreFetched: selectAiOraQuestionScoreFetched(),
});

const dispatchToProps = {
    getAiOraQuestionScore,
};

export default connect(stateToProps, dispatchToProps)(AiOraBoard);
